import React from "react";
import { ChildrenAnalyzerError } from "../ChildrenAnalyzerError.js";
const wrapError = (e, currentComponentName, methodName, path) => {
  if (!(e instanceof Error)) {
    throw e;
  }
  const componentPath = path.map((it, index) => {
    const { children, ...props } = it.props;
    const printProps = (props2) => {
      let result = "";
      for (const [key, value] of Object.entries(props2)) {
        if (value === void 0) {
          continue;
        }
        try {
          const valuePrinted = JSON.stringify(
            value,
            (key2, value2) => {
              if (typeof value2 === "function") {
                return "(function)";
              }
              if (React.isValidElement(value2)) {
                return "(react element)";
              }
              return value2;
            }
          );
          result += ` ${key}=${valuePrinted}`;
        } catch {
          result += ` ${key}=(failed to print a value)`;
        }
      }
      return result;
    };
    const componentName = typeof it.type === "object" && "displayName" in it.type ? it.type.displayName : null;
    const propsPrinted = printProps(props);
    const indent = "  ".repeat(index);
    return `${indent}<${componentName ?? "???"}${propsPrinted}>`;
  });
  const errorMessage = `Error during static render of ${currentComponentName} in ${methodName}:
${e.message || "unknown error"}`;
  throw new ChildrenAnalyzerError(errorMessage, {
    cause: e,
    details: `Component path:
${componentPath.join("\n")}`
  });
};
export {
  wrapError
};
//# sourceMappingURL=wrapError.js.map
